import React, { Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './style.scss';
import { Alert, Tooltip } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import dayjs from 'dayjs';
import H3CustomInput from '@Uilib/h3CustomInput';
import H3Text from '@Uilib/h3Text';
import H3FormInput from '@Uilib/h3FormInput';

/**
 *
 */
const UpdateQCCustomInputs = ({
  additionInputs, formSubmitted, customInputChange, cfWrapperClassName, disableCase, isHorizontalUi, inputClassName, labelClassName, containerClassName, hideTitle, selectedQC,
}) => {
  // eslint-disable-next-line camelcase
  function checkNumber(actualValue, comparisonType, value_1, value_2) {
    switch (comparisonType) {
    case '<':
      return Number(actualValue) < Number(value_1);
    case '>':
      return Number(actualValue) > Number(value_1);
    case '=':
      return Number(actualValue) === Number(value_1);
    case '<=':
      return Number(actualValue) <= Number(value_1);
    case '>=':
      return Number(actualValue) >= Number(value_1);
    case '!=':
      return Number(actualValue) !== Number(value_1);
    case 'BETWEEN':
      if (Number(value_2) === null) {
        return false;
      }
      return Number(actualValue) >= Number(value_1) && Number(actualValue) <= Number(value_2);
    default:
      return false;
    }
  }

  function checkDate(actualValue, comparisonType, value_1, value_2) {
    const value_2_1 = Number(value_2) + 1;
    if (!actualValue) {
      // Handle the case where actualValue is undefined, null, or an empty string
      return false; // Or true, depending on how you want to handle this case
    }

    const actualDate = dayjs(actualValue, 'YYYY-MM-DD');

    if (!actualDate.isValid()) {
      return false;
    }

    const currentDate = dayjs(); // Today's date

    switch (comparisonType) {
    case '<':
      return actualDate.isBefore(currentDate.add(Number(value_1), 'days'), 'day');
    case '>':
      return actualDate.isAfter(currentDate.add(Number(value_1), 'days'), 'day');
    case '=':
      return actualDate.isSame(currentDate.add(Number(value_1), 'days'), 'day');
    case '<=':
      return actualDate.isSameOrBefore(currentDate.add(Number(value_1), 'days'), 'day');
    case '>=':
      return actualDate.isAfter(currentDate.add(Number(value_1), 'days'), 'day') || actualDate.isSame(currentDate.add(Number(value_1), 'days'), 'day');
    case '!=':
      return !actualDate.isSame(currentDate.add(Number(value_1), 'days'), 'day');
    case 'BETWEEN': {
      if (isNaN(value_1) || isNaN(value_2_1)) {
        return false;
      }
      const startDate = currentDate.add(Number(value_1 - 1), 'days');
      const endDate = currentDate.add(Number(value_2_1), 'days');
      return actualDate.isAfter(startDate, 'day') && actualDate.isBefore(endDate, 'day');
    }
    default:
      return false;
    }
  }

  function checkDropdown(actualValue, comparisonType, value_1) {
    switch (comparisonType) {
    case 'IN':
      // Check if the actualValue is included in the value_1 array
      return value_1.includes(actualValue);
    case 'NOT IN':
      // Check if the actualValue is not included in the value_1 array
      return !value_1.includes(actualValue);
    default:
      // If an unknown comparisonType is provided, you could return false or throw an error
      return false;
    }
  }

  return (
    <div className="qc-cf_wrapper">
      <div className={isHorizontalUi ? `cf_horizontal ${cfWrapperClassName || ''}` : cfWrapperClassName}>
        <div
          className="ant-row"
        >
          {additionInputs?.filter((item) => (item?.type?.toUpperCase() !== 'ATTACHMENT' && item?.type?.toUpperCase() !== 'CHECKBOX' && item?.type?.toUpperCase() !== 'TEXTAREA' && !item?.pass_condition?.rule && !item?.pass_condition?.value_1))?.map((additionInput, index) => (
            <React.Fragment key={additionInput?.key}>
              <div key={additionInput?.key} className="ant-col-md-24 ant-col-xs-24">
                <H3CustomInput
                  containerClassName={` ${containerClassName || '' }`}
                  labelClassName={labelClassName || ''}
                  inputClassName={`orgFormInput ${inputClassName || ''}`}
                  inputErrorClassName="cf__input-error"
                  type={additionInput?.type?.toUpperCase()}
                  required={additionInput?.is_required}
                  label={additionInput?.name}
                  options={additionInput?.dropDown_values?.length ? additionInput?.dropDown_values : []}
                  placeholder={additionInput?.placeholder}
                  referenceValue={additionInput?.reference_value}
                  onChange={(value) => customInputChange(value, additionInput?.key)}
                  value={additionInput?.value}
                  showError={formSubmitted && additionInput?.is_required && !additionInput?.value}
                  disabled={disableCase}
                  isHorizontalUi={isHorizontalUi}
                  currentStatus={selectedQC?.status === 'COMPLETED'}
                />
              </div>
              {isHorizontalUi && <div key={additionInput?.key} className="ant-col-md-12" /> }
            </React.Fragment>
          ))}

          {additionInputs?.filter((item) => (item?.type?.toUpperCase() !== 'ATTACHMENT' && item?.type?.toUpperCase() !== 'CHECKBOX' && item?.type?.toUpperCase() !== 'TEXTAREA' && item?.pass_condition?.rule && item?.pass_condition?.value_1))?.map((additionInput, index) => (
          // eslint-disable-next-line react/jsx-key
            <div
              className="ant-row"
              style={{
                alignItems: 'center',
              }}
            >
              <div className="ant-col-md-6" style={{ border: '1px solid #d6e4fc' }}>
                <H3Text
                  text={additionInput?.name}
                  className="qc-inputs__table-label"
                  required={additionInput?.is_required}
                />
              </div>
              <div className="ant-col-md-9">
                <H3CustomInput
                  containerClassName="orgInputContainer approve-qc__input-row__input"
                  labelClassName="orgFormLabel"
                  inputClassName="orgFormInput input"
                  inputErrorClassName="cf__input-error"
                  type={additionInput?.type?.toUpperCase()}
                  required={additionInput?.is_required}
                  options={additionInput?.dropDown_values?.length ? additionInput?.dropDown_values : []}
                  placeholder={additionInput?.placeholder}
                  // referenceValue={additionInput.pass_condition?.value_1}
                  onChange={(value) => customInputChange(value, additionInput?.key)}
                  value={additionInput?.value}
                  showError={formSubmitted && additionInput?.is_required && !additionInput?.value}
                  disabled={disableCase}
                  width="318px"
                  name={additionInput?.name}
                  currentStatus={selectedQC?.status === 'COMPLETED'}
                />
              </div>
              <div
                className="ant-col-md-1"
                style={{
                  padding: '3px 4px 0px 10px',
                }}
              >
                {
                    additionInput?.value && (
                    additionInput.type === 'DATE'
                      ? !checkDate(additionInput.value, additionInput.pass_condition?.rule, additionInput.pass_condition?.value_1, additionInput.pass_condition?.value_2) ? (
                        <Tooltip title="QC Line is rejected" color="red">
                          <FontAwesomeIcon icon={faTriangleExclamation} color="red" style={{ fontSize: '14px' }} />
                        </Tooltip>
                      ) : null
                      : additionInput.type === 'NUMBERS'
                        ? !checkNumber(additionInput.value, additionInput.pass_condition?.rule, additionInput.pass_condition?.value_1, additionInput.pass_condition?.value_2) ? (
                          <Tooltip title="QC Line is rejected" color="red">
                            <FontAwesomeIcon icon={faTriangleExclamation} color="red" style={{ fontSize: '14px' }} />
                          </Tooltip>
                        ) : null
                        : additionInput.type === 'DROPDOWN'
                          ? !checkDropdown(additionInput.value, additionInput.pass_condition?.rule, additionInput.pass_condition?.value_1) ? (
                            <Tooltip title="QC Line is rejected" color="red">
                              <FontAwesomeIcon icon={faTriangleExclamation} color="red" style={{ fontSize: '14px' }} />
                            </Tooltip>
                          ) : null
                          : null
                  )
                }
                {
                    additionInput?.value && (
                    additionInput.type === 'DATE'
                      ? checkDate(additionInput.value, additionInput.pass_condition?.rule, additionInput.pass_condition?.value_1, additionInput.pass_condition?.value_2) ? (
                        <Tooltip title="QC Line is Approved" color="rgb(65, 137, 248)">
                          <FontAwesomeIcon icon={faCircleCheck} color="rgb(34, 197, 94)" style={{ fontSize: '14px' }} />
                        </Tooltip>
                      ) : null
                      : additionInput.type === 'NUMBERS'
                        ? checkNumber(additionInput.value, additionInput.pass_condition?.rule, additionInput.pass_condition?.value_1, additionInput.pass_condition?.value_2) ? (
                          <Tooltip title="QC Line is Approved" color="rgb(65, 137, 248)">
                            <FontAwesomeIcon icon={faCircleCheck} color="rgb(34, 197, 94)" style={{ fontSize: '14px' }} />
                          </Tooltip>
                        ) : null
                        : additionInput.type === 'DROPDOWN'
                          ? checkDropdown(additionInput.value, additionInput.pass_condition?.rule, additionInput.pass_condition?.value_1) ? (
                            <Tooltip title="QC Line is Approved" color="rgb(65, 137, 248)">
                              <FontAwesomeIcon icon={faCircleCheck} color="rgb(34, 197, 94)" style={{ fontSize: '14px' }} />
                            </Tooltip>
                          ) : null
                          : null
                  )
                }
              </div>
              <div className="ant-col-md-8">
                <Alert
                  message={
                additionInput?.pass_condition?.rule === 'BETWEEN' ? (
                  <span>
                    <span>
                      {`Should be between ${additionInput?.pass_condition?.value_1} and ${additionInput?.pass_condition?.value_2}`}
                    </span>
                  </span>
                ) : (
                  <span>
                    <span>
                      {`Should be ${additionInput?.pass_condition?.rule} ${additionInput?.pass_condition?.value_1}`}
                    </span>
                  </span>
                )
                  }
                  type="info"
                />
              </div>
            </div>
          ))}

          {additionInputs?.filter((item) => ((item?.type?.toUpperCase() === 'ATTACHMENT' || item?.type?.toUpperCase() === 'CHECKBOX' || item?.type?.toUpperCase() === 'TEXTAREA')))?.map((additionInput, index) => (
            <Fragment key={additionInput?.key}>
              <div className="ant-col-md-24 ant-col-xs-24">
                <H3CustomInput
                  containerClassName={`orgInputContainer ${containerClassName || '' } ${(isHorizontalUi ? 'ant-row' : '') }`}
                  labelClassName={`orgFormLabel ${isHorizontalUi ? 'ant-col-md-6 ' : ''}${ labelClassName || ''}`}
                  inputClassName={`orgFormInput ${isHorizontalUi ? 'ant-col-md-18 ' : ''}${inputClassName || ''}`}
                  inputErrorClassName="cf__input-error"
                  type={additionInput?.type?.toUpperCase()}
                  required={additionInput?.is_required}
                  referenceValue={additionInput?.reference_value}
                  label={additionInput?.name}
                  options={additionInput?.dropDown_values?.length ? additionInput?.dropDown_values : []}
                  placeholder={additionInput?.placeholder}
                  onChange={(value) => customInputChange(value, additionInput?.key)}
                  value={additionInput?.value}
                  showError={(formSubmitted && additionInput?.is_required && !additionInput?.value) || (formSubmitted && additionInput?.is_required && additionInput?.type?.toUpperCase() === 'ATTACHMENT' && additionInput?.value?.length === 0)}
                  disabled={disableCase}
                  isHorizontalUi={isHorizontalUi}
                  currentStatus={selectedQC?.status === 'COMPLETED'}
                  isFromQC
                />
              </div>
              {isHorizontalUi && <div className="ant-col-md-12" /> }
            </Fragment>
          ))}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = () => ({

});

const mapDispatchToProps = () => ({
});

UpdateQCCustomInputs.propTypes = {
  additionInputs: PropTypes.any,
  formSubmitted: PropTypes.any,
  customInputChange: PropTypes.any,
  cfWrapperClassName: PropTypes.any,
  disableCase: PropTypes.any,
  isHorizontalUi: PropTypes.any,
  inputClassName: PropTypes.any,
  labelClassName: PropTypes.any,
  containerClassName: PropTypes.any,
  hideTitle: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(UpdateQCCustomInputs));
